import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    card: {
        background: '#fff',
        // Figma 9235:15895 Card strokes: SOLID #E5E7EB α=1.0 weight=1.
        border: '1px solid #E5E7EB',
        borderRadius: 24,
        padding: '42px 32px 32px',
        // Figma 9235:15895 Card effects (2 stacked DROP_SHADOW):
        //   1. blur=4 offset=0,2 spread=-2 rgba(0,0,0,0.05)
        //   2. blur=6 offset=0,4 spread=-1 rgba(0,0,0,0.10)
        // Bumped alpha 2x (0.10/0.20) since figma's α tends to render subtler
        // in browser than in design tool — keeps stack form, more visible.
        boxShadow: '0 2px 4px -2px rgba(0, 0, 0, 0.10), 0 8px 16px -1px rgba(0, 0, 0, 0.20)',
        width: '100%',
        boxSizing: 'border-box',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            padding: '38px 32px 32px',
            borderRadius: 24,
            height: 'auto',
        },
        [theme.breakpoints.down(380)]: {
            padding: '30px 24px 24px',
        },
    },
    // Figma 9235:15874 both cards (Lite + Full) have identical strokes
    // (#E5E7EB) — recommended card MUST keep the border. No-op class kept
    // for component API compatibility; intentionally empty.
    cardRecommended: {},
    title: {
        margin: 0,
        color: '#3555f4',
        fontSize: 20,
        fontWeight: 800,
        lineHeight: '24px',
        letterSpacing: 0,
        marginBottom: 16,
        [theme.breakpoints.down('sm')]: {
            fontSize: 18,
            lineHeight: '24px',
        },
        '& > span': {
            display: 'block',
        },
    },
    priceOriginal: {
        fontSize: 16,
        fontWeight: 600,
        color: '#E53E3E',
        textDecoration: 'line-through',
        lineHeight: '20px',
        marginBottom: 4,
        [theme.breakpoints.down('sm')]: {
            marginBottom: 0,
        },
    },
    priceRow: {
        display: 'flex',
        alignItems: 'baseline',
        marginBottom: 24,
        '& > *:not(:last-child)': { marginRight: 4 },
    },
    priceMain: {
        fontSize: 36,
        fontWeight: 800,
        color: '#111827',
        lineHeight: '44px',
        [theme.breakpoints.down('sm')]: {
            fontSize: 28,
        },
    },
    priceUnit: {
        fontSize: 16,
        color: '#6B7280',
        fontWeight: 700,
    },
    benefitList: {
        listStyle: 'none',
        padding: 0,
        margin: 0,
        marginBottom: 32,
        flex: 1,
    },
    benefitItem: {
        display: 'flex',
        alignItems: 'flex-start',
        fontSize: 15,
        color: '#374151',
        lineHeight: '22px',
        marginBottom: 12,
        '&:last-child': { marginBottom: 0 },
        '& > span:first-child': { marginRight: 12 },
        [theme.breakpoints.down('sm')]: {
            fontSize: 15,
            lineHeight: '22px',
        },
    },
    benefitIcon: {
        width: 20,
        height: 20,
        flexShrink: 0,
        marginTop: 1,
    },
    cta: {
        background: '#E0E0FF',
        color: '#1F2937',
        fontWeight: 700,
        padding: '14px 24px',
        borderRadius: 9999,
        border: 'none',
        fontSize: 16,
        cursor: 'pointer',
        width: '100%',
        '&:hover': { background: '#D0D0FF' },
    },
    ctaRecommended: {
        background: '#3555f4',
        color: '#fff',
        '&:hover': { background: '#2A45C0' },
    },
    saveBadge: {
        position: 'absolute',
        top: -14,
        left: '50%',
        transform: 'translateX(-50%)',
        background: '#3555f4',
        color: '#fff',
        padding: '6px 16px',
        borderRadius: 9999,
        fontSize: 14,
        fontWeight: 700,
    },
    voucherApplied: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 8,
        '& > *:not(:last-child)': { marginRight: 6 },
        [theme.breakpoints.down('sm')]: {
            marginBottom: 12,
            '& > *:not(:last-child)': { marginRight: 4 },
        },
    },
    voucherAppliedPackageList: {
        [theme.breakpoints.down('sm')]: {
            marginTop: 12,
            minWidth: 134,
        },
    },
    voucherText: {
        color: '#16A34A',
        fontSize: 14,
        fontWeight: 700,
        whiteSpace: 'nowrap',
    },
    nextBilling: {
        fontSize: 14,
        fontWeight: 700,
        color: '#111827',
        marginTop: -16,
        marginBottom: 24,
    },
    cardWrap: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        maxWidth: 380,
        minWidth: 380,
        boxSizing: 'border-box',
        margin: '0 12px',
        height: '100%',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            margin: 0,
            height: 'auto',
        },
    },
}));

export default useStyles;
